export default "__VITE_ASSET__CnhG2fAH__"